<template>
  <div class="course-item box-item" @click="toUrl(`/course/detail?id=${itemData.id}`)">
    <div class="img-wrap">
      <el-image fit="cover" class="img" :src="itemData.img"></el-image>
      <i class="iconfont icon-bofang"></i>
    </div>
    <div class="title">{{itemData.title}}</div>
    <div class="desc z-flex z-flex-between">
      <div class="category">{{itemData.category}}</div>
      <div class="views">{{itemData.viewNum}}人学习过</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "caifengItem",
  props: {
    itemData: {
      type:Object,
      default:()=>{},
    }
  },
  data() {
    return {
      
    };
  },
  mounted() {
    
  },
  methods: {
    toUrl(url){
      this.$router.push({
        path:url,
      })
    }
  },
};
</script>

<style lang="scss" scoped>
.img-wrap{
  position: relative;
  .icon-bofang{
    font-size: 50px;
    color: #fff;
    text-shadow: 0 0 15px rgba(0,0,0,.35);
    position: absolute;
    left:50%;
    top: 50%;
    transform: translate(-50%,-50%);
  }
}
.category{
  flex: 1;
  margin-right: 10px;
  @extend %textOverflow;
}
</style>
